import ScrollCarousel from '../../components/ScrollCarousel';

const SELECTORS = {
  viewport: '[data-blog-latest-pods-viewport]',
  track: '[data-blog-latest-pods-track]',
};

const carousels = [];

const init = () => {
  carousels.forEach((carousel) => {
    try {
      carousel.destroy();
    } catch (error) {
      console.log('err:', error);
    }
  });

  carousels.length = 0;

  // Desktop shows the pods as a static grid; the carousel is mobile-only.
  if (window.innerWidth > 767) {
    return;
  }

  document.querySelectorAll('[blog-latest-pods-carousel]').forEach((el) => {
    const track = el.querySelector(SELECTORS.track);
    if (!track || track.children.length === 0) {
      return;
    }

    // Flickity defaults.
    const carousel = new ScrollCarousel(el, {
      selectors: SELECTORS,
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      slidesPerView: 1,
      ariaLabel: 'Latest articles carousel',
    });
    carousels.push(carousel);
  });
};

const resizeHandler = () => {
  clearTimeout(resizeHandler.debounce);
  resizeHandler.debounce = setTimeout(() => {
    init();
  }, 250);
};

export default function () {
  if (document.querySelectorAll('[blog-latest-pods-carousel]').length === 0) {
    return;
  }

  init();
  window.addEventListener('resize', resizeHandler);
}
